import React from 'react';

const TextMessage = ({ role, content }) => {
    return (
        <div className={`copilot-chat-message ${role === 'user' ? 'user' : 'assistant'}`}>
            {content}
        </div>
    );
};

export default TextMessage;
